class CartRecommendations extends HTMLElement {
  constructor() {
    super();

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);

// Kokoualush: one-click "+ Add" for cart upsells
document.addEventListener('click', function (e) {
  var b = e.target.closest('.kk-upsell-add');
  if (!b) return;
  e.preventDefault();
  b.disabled = true; b.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: +b.dataset.variant, quantity: 1 }], sections: 'mini-cart,cart-icon-bubble' })
  }).then(function (r) { return r.json(); }).then(function (s) {
    var mc = document.querySelector('mini-cart');
    if (s && s.sections && mc && mc.renderContents) { mc.renderContents(s); } else { location.reload(); }
  }).catch(function () { location.reload(); });
});
